import { Bars3Icon } from '@heroicons/react/24/outline';
import { useLocation } from 'react-router-dom';

const pageTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/inventory': 'Inventory',
  '/outshipments': 'Outshipments',
  '/transfers': 'Transfers',
  '/new-accounts': 'New Accounts',
  '/addresses': 'Address Book',
  '/products': 'Products',
  '/accounts': 'Accounts',
  '/audit': 'Audit Log',
  '/sftp': 'SFTP Monitor',
  '/exports': 'Exports',
};

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const location = useLocation();
  const basePath = '/' + (location.pathname.split('/')[1] ?? '');
  const title = pageTitles[basePath] ?? 'AIGftpwatch';

  return (
    <header className="flex h-16 items-center gap-4 border-b border-silver-200 bg-white px-6">
      <button onClick={onMenuClick} className="rounded-lg p-1 text-silver-500 hover:bg-silver-100 lg:hidden">
        <Bars3Icon className="h-6 w-6" />
      </button>
      <h1 className="text-xl font-semibold text-silver-900">{title}</h1>
    </header>
  );
}
